import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Card, CardBody } from "reactstrap";
import { LineChart,XAxis,YAxis,CartesianGrid,Line } from "recharts";

const HighChart = () => {

 
 const data = [
  {
    name:"Jan",
    value:"10"
  },
  {
    name:"Feb",
    value:"100"
  },
  {
    name:"Mar",
    value:"80"
  },
  {
      name:"Apr",
      value:"10"
  },
  {
    name:"May",
    value:"10"
  }
  
 ]

  return (
    <Card
      className="latest-sales card-hover p-0 b-r-0"

    >
      <div className="custom-border-bottom card-header">
        <h5 style={{ fontWeight: '600' }}>Volume(m³)</h5>
      </div>
      <CardBody className="p-1  my-2" >
        <LineChart style={{width:'100%'}} width={450} height={355} data={data}>
          <XAxis dataKey="name" />
          <YAxis 
              domain={[0, 120]} 
            dataKey={"value"}
            label={{
              value: "Volumes Trend By Month",
              angle: -90,
              position: "insideLeft",
              style: { textAnchor: "middle", fontWeight: "bold" }
          }} />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <Line type="linear" dataKey="value" stroke="#2B5F60" />
         
        </LineChart>
      </CardBody>
    </Card>
  )
}

export default HighChart